import Skeleton from "@mui/joy/Skeleton";
import React, { forwardRef } from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  // Add any custom props you need here, e.g.,
  // onLoad: () => void;
  // onError: () => void;
  onImageLoad: () => void;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ src, alt, onImageLoad, onError, ...rest }, ref) => {
    const [loading, setLoading] = React.useState(true);

    return (
      <Skeleton loading={loading}>
        <img
          className="max-h-72"
          src={src}
          alt={alt}
          ref={ref}
          onLoad={() => {
            setLoading(false);
            onImageLoad();
          }}
          onError={onError}
          {...rest}
        />
      </Skeleton>
    );
  }
);

export default Image;
